export default "__VITE_ASSET__BauEAJ39__"